export class Declarante {

    model = {
        id: { value: null, export: false, table: false },
        oid: { value: null, export: false, table: false },
        idp: { value: null, export: false, table: false },
        tipo_declarante: {
            value: null,
            export: false,
            header: 'Tipo de Declarante',
            required: 'Tipo de declarante es obligatorio',
            table: true,
        },
        tipo_identificacion: {
            value: null,
            export: false,
            header: 'Tipo de identificación',
            required: 'Tipo de identificación es requerido',
            table: true,
        },
        tipo_identificacion_cy: {
            value: null,
            export: false,
            header: 'Tipo de identificación',
            required: 'Tipo de identificación es requerido',
            table: false,
        },
        identificacion: {
            value: '',
            export: true,
            header: 'Identificación',
            required: 'Identificación es requerido',
            maxLength: 'Máximo 50 caracteres',
            minLength: 'Mínimo 4 caracteres',
            max: 50,
            min: 4,
            table: true,
        },
        nombre_completo: {
            value: '',
            export: false,
            header: 'Razón social/Nombres y Apellidos',
            table: true,
        },
        nombres: {
            value: '',
            export: true,
            header: 'Nombres',
            required: 'Nombres es requerido',
            maxLength: 'Máximo 300 caracteres',
            minLength: 'Mínimo 4 caracteres',
            max: 300,
            min: 4,
            table: false
        },
        apellidos: {
            value: '',
            export: true,
            header: 'Apellidos',
            required: 'Apellidos es requerido',
            maxLength: 'Máximo 300 caracteres',
            minLength: 'Mínimo 4 caracteres',
            max: 300,
            min: 4,
            table: false
        },
        razon_social: {
            value: '',
            export: true,
            header: 'Razón Social',
            required: 'Razón Social es requerido',
            maxLength: 'Máximo 400 caracteres',
            minLength: 'Mínimo 4 caracteres',
            max: 400,
            min: 4,
            table: false
        },
        descripcion: {
            value: '',
            export: true,
            header: 'Describa la transacción u operación que realiza con la compañía:',
            required: 'Descripción es requerido',
            maxLength: 'Máximo 1000 caracteres',
            minLength: 'Mínimo 4 caracteres',
            max: 1000,
            min: 4,
            table: false
        },
        nacionalidad: { value: null, export: false, header: 'Nacionalidad', required: 'Nacionalidad es requerido', table: false },
        nacionalidad_cy: { value: null, export: false, header: 'Nacionalidad', required: 'Nacionalidad es requerido', table: false },
        genero: { value: null, export: false, header: 'Género', required: 'Género es requerido', table: false },
        fecha_nacimiento: { value: new Date(), export: false, header: 'Fecha de nacimiento/fecha de constitución:', required: 'Fecha es requerido', table: false },
        direccion_domicilio: {
            value: '',
            export: true,
            header: 'Dirección',
            required: 'Dirección domicilio es requerido',
            maxLength: 'Máximo 1000 caracteres',
            minLength: 'Mínimo 4 caracteres',
            max: 1000,
            min: 4,
            table: false
        },
        pais: { value: null, export: false, header: 'País', required: 'País es requerido', table: false },
        provincia: { value: null, export: false, header: 'Provincia', required: 'Provincia es requerido', table: false },
        ciudad: { value: null, export: false, header: 'Ciudad', required: 'Ciudad es requerido', table: false },
        canton: {
            value: '',
            export: true,
            header: 'Ciudad',
            required: 'Ciudad es requerido',
            maxLength: 'Máximo 400 caracteres',
            minLength: 'Mínimo 4 caracteres',
            max: 400,
            min: 4,
            table: false
        },
        telefono_celular: {
            value: '',
            export: true,
            header: 'Teléfono Celular',
            required: 'Teléfono celular es requerido',
            maxLength: 'Máximo 50 caracteres',
            minLength: 'Mínimo 4 caracteres',
            max: 50,
            min: 4,
            table: false
        },
        telefono_fijo: {
            value: '',
            export: true,
            header: 'Teléfono Fijo',
            required: 'Teléfono fijo es requerido',
            maxLength: 'Máximo 50 caracteres',
            minLength: 'Mínimo 4 caracteres',
            max: 50,
            min: 4,
            table: false
        },
        telefono_oficina: {
            value: '',
            export: true,
            header: 'Teléfono oficina',
            required: 'Teléfono oficina es requerido',
            maxLength: 'Máximo 50 caracteres',
            minLength: 'Mínimo 4 caracteres',
            max: 50,
            min: 4,
            table: false
        },
        telefono_domicilio: {
            value: '',
            export: true,
            header: 'Teléfono domicilio',
            required: 'Teléfono domicilio es requerido',
            maxLength: 'Máximo 50 caracteres',
            minLength: 'Mínimo 4 caracteres',
            max: 50,
            min: 4,
            table: false
        },
        estado_civil: {
            value: null,
            export: false,
            header: 'Estado Civil',
            required: 'Estado Civil es requerido',
            table: false
        },
        apellidos_conyugue: {
            value: '',
            export: true,
            header: 'Apellido Cónyugue',
            required: 'Apellidos del cónyugue es requerido',
            maxLength: 'Máximo 400 caracteres',
            minLength: 'Mínimo 4 caracteres',
            max: 400,
            min: 4,
            table: false
        },
        nombres_conyugue: {
            value: '',
            export: true,
            header: 'Nombres Cónyugue',
            required: 'Nombres del cónyugue es requerido',
            maxLength: 'Máximo 400 caracteres',
            minLength: 'Mínimo 4 caracteres',
            max: 400,
            min: 4,
            table: false
        },
        identificacion_conyugue: {
            value: '',
            export: false,
            header: 'Identificación Cónyugue',
            required: 'Identificación del cónyugue es requerido',
            maxLength: 'Máximo 50 caracteres',
            minLength: 'Mínimo 4 caracteres',
            max: 50,
            min: 4,
            table: false
        }
    }

    optionLabel = 'nombre';
}